<header class="background-header classic-background"></header>
<section class="main-side-nav"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
	<section class="container admin-dashboard-parent roles-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Roles'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Roles</h1>
			</div>
		</section>
		<!-- Search -->
		<section class="all-users-line-presentation">
			<div class="search-section">
				<div class="accounts-number">
					<span>
						<!-- {{users.length}} --> Roles
					</span>
				</div>
				<div class="buttons-managment">
					<input type="text" class="dashboard-input" placeholder="Last Name">
					<input type="button" class="btn btn-primary search-btn" value="Search">
					<input type="button" class="btn btn-primary create-btn" value="Create User">
					<input type="button" class="btn btn-primary export-btn" value="Export" (click)="exportAsXLSX()">
				</div>
			</div>
		</section>
		<!-- Table data -->
		<section class="all-users-data">
			<div class="table-responsive admin-dashboard-table">
				<table class="table table-borderless table-hover">
					<thead>
						<tr>
							<th scope="col">First Name</th>
							<th scope="col">Last Name</th>
							<th scope="col">Email</th>
							<th scope="col">Permission 1</th>
							<th scope="col">Permission 2</th>
							<th scope="col">Permission 3</th>
							<th scope="col">Permission 4</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
	</section>
</section>